'use client'

import { useEffect } from 'react'

export default function DynamicStyleLoader({ customVersion }) {
    useEffect(() => {
        // 如果没有 customVersion，加载 default.css
        const styleVersion = customVersion || 'default';
        
        // 检查是否已经加载过这个样式
        const styleId = `custom-style-${styleVersion}`;
        if (document.getElementById(styleId)) return;
        
        // 动态添加 link 标签
        const link = document.createElement('link');
        link.id = styleId;
        link.rel = 'stylesheet';
        link.href = `/styles/${styleVersion}.css`;
        document.head.appendChild(link);
        
        return () => {
            // 清理：组件卸载时移除样式
            const existingLink = document.getElementById(styleId);
            if (existingLink) {
                existingLink.remove();
            }
        };
    }, [customVersion]);
    
    return null;
}

